import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

// material-ui
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

// project import
import MainCard from '../MainCard';

export default function Breadcrumbs({ navigation, title, ...others }) {
  const theme = useTheme();
  const location = useLocation();
  const [main, setMain] = useState();
  const [item, setItem] = useState();

  // set active item state
  const getCollapse = (menu) => {

    if (menu.children) {
      menu.children.filter((collapse) => {
        if (collapse.visible) {
          if (collapse.type && collapse.type === 'collapse') {
            getCollapse(collapse);
          } else if (collapse.type && collapse.type === 'item') {
            if (location.pathname === collapse.url) {
              setMain(menu);
              setItem(collapse);
            }
          }
        }
        return false;
      });
    }
  };

  useEffect(() => {
    navigation?.items?.map((menu) => {

      if (menu.type && menu.type === 'group') {
        getCollapse(menu);
      }
      return false;
    });
  });

  // only used for component demo breadcrumbs
  if (location.pathname === '/breadcrumbs') {
    location.pathname = '/dashboard/analytics';
  }

  let mainContent;
  let itemContent;
  let breadcrumbContent = <Typography />;
  let itemTitle = '';

  // collapse item
  if (main && main.type === 'collapse') {
    mainContent = (
      <Typography
        component={Link}
        to={document.location.pathname}
        variant="body1"
        sx={{
          textDecoration: 'none',
          color: theme.palette.text.secondary,
          fontWeight: 500,
          transition: theme.transitions.create(['color'], {
            duration: theme.transitions.duration.short
          }),
          '&:hover': {
            color: theme.palette.primary.main
          }
        }}
      >
        {main.title}
      </Typography>
    );
  }

  // items
  if (item && item.type === 'item') {
    itemTitle = item.title;
    itemContent = (
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.text.primary,
          fontWeight: 600
        }}
      >
        {itemTitle}
      </Typography>
    );

    // main
    if (item.breadcrumbs !== false && item.visible) {
      breadcrumbContent = (
        <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: theme.palette.background.default }}>
          <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
            <Grid item sx={{ width: '100%' }}>
              <MuiBreadcrumbs
                aria-label="breadcrumb"
                sx={{
                  '& .MuiBreadcrumbs-li': {
                    fontSize: '0.95rem'
                  },
                  '& .MuiBreadcrumbs-separator': {
                    mx: 1.5,
                    color: theme.palette.divider
                  }
                }}
              >
                <Typography
                  component={Link}
                  to="/"
                  sx={{
                    textDecoration: 'none',
                    color: theme.palette.text.secondary,
                    fontWeight: 500,
                    transition: theme.transitions.create(['color'], {
                      duration: theme.transitions.duration.short
                    }),
                    '&:hover': {
                      color: theme.palette.primary.main
                    }
                  }}
                >
                  Trang chủ
                </Typography>
                {mainContent}
                {itemContent}
              </MuiBreadcrumbs>
            </Grid>
          </Grid>
        </Box>
      );
    }
  }

  return breadcrumbContent;
}

Breadcrumbs.propTypes = {
  card: PropTypes.bool,
  custom: PropTypes.bool,
  divider: PropTypes.bool,
  heading: PropTypes.string,
  icon: PropTypes.bool,
  icons: PropTypes.bool,
  links: PropTypes.array,
  maxItems: PropTypes.number,
  rightAlign: PropTypes.bool,
  separator: PropTypes.any,
  title: PropTypes.bool,
  titleBottom: PropTypes.bool,
  sx: PropTypes.any,
  others: PropTypes.any
};
